import { useEffect, useState } from "react"
import { NavLink, useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { logout } from "../../redux/authSlice";
import { handleForm } from "../../redux/trainingForm";
import userProfileIcon from "../../assets/User-Profile-Image.png"
import courseAPi from '../../apiProvider/api';
import apiProvider from '../../apiProvider/categoryApi';
import ApiProvider from "../../apiProvider/addToCartApi";
import { IMAGE_URL } from "../../network/apiClient";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { useTranslation } from "../../context/TranslationContext";
import { useCurrency } from "../../context/CurrencyContext";


const Header = () => {
    const isAuthenticated = useSelector((state) => state.auth.token);
    const [cartCount, setCartCount] = useState(0);
    const [navbarClass, setNavbarClass] = useState("navbar-expand-lg");
    const [selectedBanner, setBannerCourse] = useState(null);
    const [courseOptions, setCourseOptions] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const disPatch = useDispatch()
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();
    const { currency, setCurrency } = useCurrency();

    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedSearch, setSelectedSearch] = useState(null);
    const [searchTimeout, setSearchTimeout] = useState(null);

    const closeNavbar = () => {
        setMenuOpen(false);
    };
    const handleChangeLanguage = (lang) => {
        setCurrentLanguage(lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === 'ar' ? 'ltr' : 'ltr';
        closeNavbar();
    };

    const naviGateToPage = async (id) => {
        disPatch(handleForm({ isGetList: true, id: id }));
        navigate(`/training/${id}`);
        closeNavbar();
    }



    const [isProgram, setisProgram] = useState(false)
    const [categoryList, setCategoryList] = useState([])
    const [productList, setProductList] = useState([]);
    const customStyles = {
        container: (base) => ({
            ...base,
            width: '250px'
        }),
        control: (base, state) => ({
            ...base,
            height: '36px',
            minHeight: '36px',
            fontSize: '14px',
            borderRadius: '8px',
            borderColor: '#ddd',
            boxShadow: 'none',
            textAlign: 'left', // ✨ added to ensure left align inside control
            '&:hover': {
                borderColor: '#ccc'
            }
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0 8px',
            justifyContent: 'flex-start' // ✨ force left alignment inside container
        }),
        singleValue: (base) => ({
            ...base,
            textAlign: 'left',
            color: '#582d86',
            marginLeft: '2px'
        }),
        input: (base) => ({
            ...base,
            padding: 0,
            margin: 0,
            width: '100%',
            textAlign: 'left', // ✨ important
        }),
        placeholder: (base) => ({
            ...base,
            textAlign: 'left',
            marginLeft: '2px',
            color: '#111'
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            textAlign: 'left',
            overflow: 'hidden !important',      // 💪 force no scrollbars
            maxHeight: '250px !important',       // 💪 prevent internal max-height
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            WebkitOverflowScrolling: 'auto',    // stop iOS momentum scrolling
            scrollbarWidth: 'none',             // for Firefox
            msOverflowStyle: 'none'             // for IE 10+
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: '250px',         // ✅ limit height
            overflowY: 'auto',          // ✅ enable scrolling
            paddingRight: 0,
            scrollbarWidth: 'none',     // Firefox
            msOverflowStyle: 'none',    // IE/Edge
            '&::-webkit-scrollbar': {   // Chrome/Safari
                display: 'none'
            }
        }),
        option: (base, state) => ({
            ...base,
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'left',
            backgroundColor: state.isSelected ? '#e5d5f9' : 'white',
            color: state.isSelected ? '#582d86' : '#333',
            '&:hover': {
                backgroundColor: '#f2e9fb',
                color: '#582d86'
            }
        }),
        indicatorsContainer: () => ({
            display: 'none'
        })
    };



    // const courseOptions = [
    //     { value: 'react', label: 'React for Beginners' },
    //     { value: 'node', label: 'Node.js Masterclass' },
    //     { value: 'python', label: 'Python Bootcamp' },
    //     { value: 'java', label: 'Java Essentials' }
    // ];
    // useEffect(() => {
    //     setSelectedCourse(null);
    // }, [location.pathname]);

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            console.log("selectedOption", selectedOption)
            const product = selectedOption.product;
            const categorySlug = product?.categoryIdDetails?.[0]?.slug || "product";
            const productId = product?._id;

            if (productId) {
                navigate(`/${categorySlug}/${productId}`);
                setSelectedSearch(null);
                closeNavbar();
            }
        } else {
            navigate("/");
            setSelectedSearch(null);
            closeNavbar();
        }
    };

    // const closeNavbar = () => {
    //     const navbarCollapse = document.getElementById("navbarNav");
    //     if (navbarCollapse && navbarCollapse.classList.contains("show")) {
    //         const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
    //             toggle: false
    //         });
    //         bsCollapse.hide();
    //     }
    // };



    useEffect(() => {
        closeNavbar();
    }, [location.pathname]);






    const getCartCount = async () => {
        let count = 0;

        // 1. Local Storage (Legacy/Dhoti)
        const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
        count += guestCart.length;

        // 2. API (Sarees / Authenticated / Guest-Server)
        try {
            const token = localStorage.getItem('userToken');
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const guestId = localStorage.getItem('guestUserId');

            let result;
            if (token && user._id) {
                result = await ApiProvider.getCart(user._id, { type: 'user', userType: 'user' });
            } else if (guestId) {
                result = await ApiProvider.getCart(guestId, { type: 'guest', userType: 'guest' });
            }

            if (result && result.status && result.response) {
                const responseData = result.response.data || result.response;
                const cartData = Array.isArray(responseData) ? responseData[0] : responseData;
                if (cartData && cartData.products) {
                    count += cartData.products.length;
                }
            }
        } catch (error) {
            // calculated count from local storage is still preserved
        }

        setCartCount(count);
    };

    const getCategoryDetails = async () => {
        try {
            const result = await courseAPi.getCategory();

            if (result.status && result.response) {
                result.response.data.data.map((ival) => {
                    ival.label = ival.name
                    ival.value = ival._id
                    ival.slug = ival.slug
                })
                setCourseOptions(result.response.data.data)
            } else {
                // setCartCount(0);
            }
        } catch (error) {
            console.error("Error fetching course details:", error);
        }
    };


    useEffect(() => {
        getCartCount();

        const handleCartUpdate = () => {
            getCartCount();
        };

        window.addEventListener('cartUpdated', handleCartUpdate);

        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, [location.pathname]);

    useEffect(() => {
        getCategoryDetails();
        getProductList();
    }, []);



    useEffect(() => {

        const handleScroll = () => {
            const navbarDesktop = document.getElementById("navbar-desktop");
            const navbarMobile = document.getElementById("navbar-mobile");

            if (window.scrollY > 20) {
                setScrolled(true);
                if (navbarDesktop) navbarDesktop.classList.add("navbar-fixed");
                if (navbarMobile) navbarMobile.classList.add("navbar-fixed");
                setNavbarClass("navbar-expand-lg mt-0 navbar-fixed");
            } else {
                setScrolled(false);
                if (navbarDesktop) navbarDesktop.classList.remove("navbar-fixed");
                if (navbarMobile) navbarMobile.classList.remove("navbar-fixed");
                setNavbarClass("navbar-expand-lg mt-3");
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [location.pathname]);

    useEffect(() => {
        getProgramList();
    }, []);

    const getProgramList = async () => {
        const result = await apiProvider.getCategoryList();
        if (result && result.status && result.response) {
            setCategoryList(result.response.data)
        }
    };

    const getProductList = async () => {
        const result = await apiProvider.getProduct('', 20);
        if (result && result.status && result.response) {
            console.log("productList :", result.response.data?.data)
            setProductList(result.response.data?.data);
        }
    };

    const fetchFilteredProducts = (searchText) => {
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        const timeout = setTimeout(async () => {
            const result = await apiProvider.getProduct(searchText, 20);
            if (result && result.status && result.response) {
                setProductList(result.response.data?.data || []);
            }
        }, 300);

        setSearchTimeout(timeout);
    };

    const handleInputChange = (inputValue, { action }) => {
        if (action === "input-change") {
            fetchFilteredProducts(inputValue);
        }
    };
    const Logout = async () => {
        if (isAuthenticated) {
            await courseAPi.logout();
            disPatch(logout({ isAuthenticated: false }));
            navigate("/login");
        }
    }

    const editForm = async (id) => {
        disPatch(handleForm({ isGetList: true, id: id }));
        navigate(`/training/${id}`);
        setisProgram(false);
        // / Close the Bootstrap modal
        const modalElement = document.getElementById("courseModal");
        if (modalElement) {
            const modal = window.bootstrap.Modal.getInstance(modalElement) || new window.bootstrap.Modal(modalElement);
            modal.hide();
        }
    }


    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (!selectedSearch) {
                navigate("/");
                closeNavbar();
            }
        }
    };



    return (
        <>
            <div className="headerDiv position-absolute top-2 mt-2 w-100 webview">
                <nav id="navbar-desktop" className={`navbar sticky-top position-fixed ${navbarClass} navbar-light custom-header-bg shadow-sm`}>
                    <div className="container d-flex align-items-center">
                        {/* Logo */}
                        <Link className="navbar-brand fw-bold me-4" to="/">
                            <img src="/img/logo/header-logo.png" style={{ width: "50px", height: "auto", padding: "0px" }} alt="Logo" />
                        </Link>

                        {/* Navbar Toggle for Mobile */}
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* Navbar Content */}
                        <div className="collapse navbar-collapse align-items-center" id="navbarNav">
                            {/* Left Side - Programs Dropdown (Commented Out) & Search */}
                            <div className="d-flex align-items-center flex-grow-1 pro-drop-div" >
                                {/* <div className="dropdown d-flex align-items-center me-4">
                                    <li data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" onClick={() => setisProgram(!isProgram)} className={`nav-link d-flex align-items-center ${isProgram ? "text-bg-dark-color" : ""}`}>
                                        <img
                                            src={isProgram ? "/img/grid-dark.png" : "/img/grid.png"}
                                            alt="Programs"
                                            width="20"
                                            className="me-2"
                                        />
                                        {translateSync('Programs')}
                                        <img
                                            src={isProgram ? "/img/down-arrow-dark.png" : "/img/down-arrow-dark.png"}
                                            style={{
                                                width: "17px",
                                                padding: "7px 0px 0px 4px",
                                                transform: "none"
                                            }}
                                            alt="down arrow"
                                        />
                                    </li>
                                </div> */}

                                <div className="position-relative search-bar">
                                    <Select
                                        options={productList.map(product => ({
                                            value: product._id,
                                            label: product.productName,
                                            product: product
                                        }))}
                                        value={selectedSearch}
                                        onChange={handleChange}
                                        placeholder={translateSync('Search Collection')}
                                        isClearable
                                        styles={customStyles}
                                        noOptionsMessage={() => translateSync('No Collections found')}
                                        onKeyDown={handleKeyDown}
                                        onInputChange={handleInputChange}
                                    />
                                    <span className="search-select-icon-end">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="gray" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.114l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.097zM12 6.5A5.5 5.5 0 1 1 1 6.5a5.5 5.5 0 0 1 11 0" />
                                        </svg>
                                    </span>
                                </div>
                            </div>

                            {/* Right Side - Navigation Links & Icons */}
                            <ul className="navbar-nav ms-auto align-items-center">
                                <li className="nav-item me-3">
                                    <NavLink to="/" className={`nav-link ${location.pathname === "/" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('Home')}
                                    </NavLink>
                                </li>
                                <li className="nav-item me-3">
                                    <NavLink to="/about" className={`nav-link ${location.pathname === "/about" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('About')}
                                    </NavLink>
                                </li>
                                {courseOptions && courseOptions.length > 0 &&
                                    courseOptions.slice(0, 3).map((course) => (
                                        <li key={course._id} className="nav-item me-3">
                                            <NavLink to={`/${course.slug}`} className={`nav-link ${location.pathname === `/${course.slug}` ? "text-bg-dark-color" : ""}`}>
                                                {course.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                <li className="nav-item me-3">
                                    <NavLink to="/blog" className={`nav-link ${location.pathname === "/blog" || location.pathname.startsWith("/blog/") ? "text-bg-dark-color" : ""}`}>
                                        Blog
                                    </NavLink>
                                </li>
                                {/* <li className="nav-item me-3">
                                    <NavLink to="/saree" className={`nav-link ${location.pathname === "/saree" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('Saree')}
                                    </NavLink>
                                </li>
                                <li className="nav-item me-3">
                                    <NavLink to="/dhoti" className={`nav-link ${location.pathname === "/dhoti" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('Dhoti')}
                                    </NavLink>
                                </li>
                                <li className="nav-item me-3">
                                    <NavLink to="/kids" className={`nav-link ${location.pathname === "/kids" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('Kids')}
                                    </NavLink>
                                </li> */}
                                <li className="nav-item me-3">
                                    <NavLink to="/contact" className={`nav-link ${location.pathname === "/contact" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('ContactUs')}
                                    </NavLink>
                                </li>

                                {/* Language Selector */}
                                {/* <li className="nav-item dropdown me-3">
                                    <a className="nav-link dropdown-toggle d-flex align-items-center" href="#" id="languageDropdown" role="button" data-bs-toggle="dropdown">
                                        {currentLanguage === 'en' ? 'EN' : 'AR'}
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <button
                                                className={`dropdown-item ${currentLanguage === 'en' ? 'active' : ''}`}
                                                onClick={() => handleChangeLanguage('en')}
                                            >
                                                English (EN)
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className={`dropdown-item ${currentLanguage === 'ar' ? 'active' : ''}`}
                                                onClick={() => handleChangeLanguage('ar')}
                                            >
                                            </button>
                                        </li>
                                    </ul>
                                </li> */}

                                {/* Currency Selector */}
                                <li className="nav-item dropdown me-3">
                                    <a className="nav-link dropdown-toggle d-flex align-items-center fw-medium text-dark text-uppercase" href="#" id="currencyDropdown" role="button" data-bs-toggle="dropdown" style={{ cursor: 'pointer', letterSpacing: '0.5px' }}>
                                        {currency}
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-end shadow border-light" aria-labelledby="currencyDropdown">
                                        <li>
                                            <button
                                                type="button"
                                                className={`dropdown-item ${currency === 'INR' ? 'active' : ''}`}
                                                onClick={() => setCurrency('INR')}
                                            >
                                                INR (₹)
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className={`dropdown-item ${currency === 'SGD' ? 'active' : ''}`}
                                                onClick={() => setCurrency('SGD')}
                                            >
                                                SGD (S$)
                                            </button>
                                        </li>
                                    </ul>
                                </li>

                                {/* Cart Icon with Notification Badge */}
                                <li className="nav-item position-relative me-3">
                                    <NavLink to="/cart" className={`nav-link ${location.pathname === "/cart" ? "active-cart" : ""}`} style={{ position: 'relative', padding: '10px' }}>
                                        <i className="fa fa-shopping-cart fa-lg" style={{ color: '#000000ff' }}></i>
                                        {cartCount > 0 && (
                                            <span
                                                className="position-absolute translate-middle badge rounded-circle"
                                                style={{
                                                    top: '5px',
                                                    left: '28px',
                                                    fontSize: '0.7rem',
                                                    backgroundColor: '#000',
                                                    color: '#fff',
                                                    minWidth: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '0px'
                                                }}
                                            >
                                                {cartCount}
                                            </span>
                                        )}
                                    </NavLink>
                                </li>

                                {/* User Dropdown */}
                                <li className="nav-item dropdown">
                                    {isAuthenticated ? (
                                        <div className="d-flex align-items-center justify-content-between gap-4">
                                            <NavLink to="/myaccount" className="nav-link d-flex align-items-center" id="userProfileLink">
                                                {/* <img src={userProfileIcon} alt="User" className="rounded-circle" style={{ width: "30px", height: "30px" }} /> */}
                                                <div className="d-flex align-items-center gap-2 account-trigger" style={{ cursor: "pointer" }}>
                                                    <i className="bi bi-person fs-4" style={{ color: "#00000" }}></i>
                                                </div>
                                            </NavLink>
                                            <button className="rbt-btn btn-gradient signup-btnnn rbt-switch-btn rbt-switch-y" onClick={Logout}>
                                                <span data-text={translateSync('Log out')}>{translateSync('Log out')}</span>
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="d-flex align-items-center justify-content-between gap-2">
                                            {/* <button className="rbt-btn btn-gradient signup-btnnn rbt-switch-btn rbt-switch-y" onClick={() => navigate("/register")}>
                                                <span data-text={translateSync('SignUp')}>{translateSync('SignUp')}</span>
                                            </button> */}
                                            <button className="rbt-btn btn-gradient signup-btnnn rbt-switch-btn rbt-switch-y" onClick={() => navigate("/login")}>
                                                <span data-text={translateSync('Login')}>{translateSync('Login')}</span>
                                            </button>
                                        </div>
                                    )}
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav >
            </div >


            {/* Mobile View */}
            <div className={`headerDiv w-100 mobileview ${scrolled ? 'scrolled' : ''}`} >
                <nav id="navbar-mobile" className={`navbar navbar-mobile ${navbarClass} navbar-light bg-white shadow-sm flex-column align-items-stretch py-2`}>
                    <div className="container-fluid px-3 d-flex align-items-center justify-content-between">
                        <Link className="navbar-brand p-0" to="/" onClick={closeNavbar}>
                            <img src="/img/logo/header-logo.png" style={{ width: "100px", height: "auto" }} alt="Logo" />
                        </Link>

                        <div className="d-flex align-items-center gap-2">
                            {/* Mobile Cart Icon */}
                            <NavLink to="/cart" onClick={closeNavbar} className="position-relative p-2" style={{ textDecoration: 'none' }}>
                                <i className="fa fa-shopping-cart fa-lg" style={{ color: '#000000ff' }}></i>
                                {cartCount > 0 && (
                                    <span
                                        className="position-absolute translate-middle badge rounded-circle"
                                        style={{
                                            top: '5px',
                                            left: '24px',
                                            fontSize: '0.65rem',
                                            backgroundColor: '#000',
                                            color: '#fff',
                                            minWidth: '18px',
                                            height: '18px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0px'
                                        }}
                                    >
                                        {cartCount}
                                    </span>
                                )}
                            </NavLink>

                            <button
                                className="navbar-toggler me-3"
                                type="button"
                                onClick={() => setMenuOpen(!menuOpen)}
                                aria-controls="navbarNav"
                                aria-expanded={menuOpen}
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                        </div>
                    </div>

                    {/* Mobile Search Bar Row */}
                    <div className="px-3 mt-2 mb-1 w-100 position-relative search-bar">
                        <Select
                            options={productList.map(product => ({
                                value: product._id,
                                label: product.productName,
                                product: product
                            }))}
                            value={selectedSearch}
                            onChange={handleChange}
                            placeholder={translateSync('Search Collection')}
                            isClearable
                            styles={{
                                ...customStyles,
                                container: (base) => ({
                                    ...base,
                                    width: '100%'
                                }),
                                control: (base) => ({
                                    ...base,
                                    height: '36px',
                                    minHeight: '36px',
                                    fontSize: '14px',
                                    borderRadius: '8px',
                                    borderColor: '#ddd',
                                    boxShadow: 'none',
                                    textAlign: 'left',
                                    display: 'flex',
                                    alignItems: 'center',
                                    '&:hover': {
                                        borderColor: '#ccc'
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '0 8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%',
                                    justifyContent: 'flex-start'
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    textAlign: 'left',
                                    marginLeft: '2px',
                                    color: '#111',
                                    position: 'absolute',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    margin: 0,
                                    padding: 0,
                                    lineHeight: 'normal'
                                }),
                                input: (base) => ({
                                    ...base,
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    alignItems: 'center'
                                })
                            }}
                            noOptionsMessage={() => translateSync('No Collections found')}
                            onKeyDown={handleKeyDown}
                            onInputChange={handleInputChange}
                        />
                        <span className="search-select-icon-end" style={{ right: '25px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="gray" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.114l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.097zM12 6.5A5.5 5.5 0 1 1 1 6.5a5.5 5.5 0 0 1 11 0" />
                            </svg>
                        </span>
                    </div>

                    <div className={`collapse navbar-collapse px-3 ${menuOpen ? 'show' : ''}`} id="navbarNav">
                            <ul className="navbar-nav">
                                {/* Mobile menu items with translations */}
                                <li className="nav-item me-3">
                                    <NavLink to="/" onClick={closeNavbar} className={`nav-link ${location.pathname === "/" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('Home')}
                                    </NavLink>
                                </li>

                                <li className="nav-item me-3">
                                    <NavLink to="/about" onClick={closeNavbar} className={`nav-link ${location.pathname === "/about" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('About')}
                                    </NavLink>
                                </li>
                                {courseOptions && courseOptions.length > 0 &&
                                    courseOptions.slice(0, 3).map((course) => (
                                        <li key={course._id} className="nav-item me-3">
                                            <NavLink to={`/${course.slug}`} onClick={closeNavbar} className={`nav-link ${location.pathname === `/${course.slug}` ? "text-bg-dark-color" : ""}`}>
                                                {course.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                <li className="nav-item me-3">
                                    <NavLink to="/blog" onClick={closeNavbar} className={`nav-link ${location.pathname === "/blog" || location.pathname.startsWith("/blog/") ? "text-bg-dark-color" : ""}`}>
                                        Blog
                                    </NavLink>
                                </li>
                                <li className="nav-item me-3">
                                    <NavLink to="/contact" onClick={closeNavbar} className={`nav-link ${location.pathname === "/contact" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('ContactUs')}
                                    </NavLink>
                                </li>

                                <li className="nav-item dropdown me-3">
                                    <a className="nav-link dropdown-toggle d-flex align-items-center fw-medium text-dark" href="#" role="button" data-bs-toggle="dropdown">
                                        Currency: {currency}
                                    </a>
                                    <ul className="dropdown-menu border-light">
                                        <li>
                                            <button
                                                type="button"
                                                className={`dropdown-item ${currency === 'INR' ? 'active' : ''}`}
                                                onClick={() => { setCurrency('INR'); closeNavbar(); }}
                                            >
                                                INR (₹)
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className={`dropdown-item ${currency === 'SGD' ? 'active' : ''}`}
                                                onClick={() => { setCurrency('SGD'); closeNavbar(); }}
                                            >
                                                SGD (S$)
                                            </button>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item me-3">
                                    <NavLink to="/cart" onClick={closeNavbar} className={`nav-link ${location.pathname === "/cart" ? "text-bg-dark-color" : ""}`}>
                                        {translateSync('Cart')}
                                    </NavLink>
                                </li>

                                <li className="nav-item dropdown me-3">
                                    {isAuthenticated ? (
                                        <>
                                            <NavLink className="nav-link" to="/myaccount" onClick={closeNavbar}>
                                                {translateSync('Profile')}
                                            </NavLink>

                                        </>
                                    ) : (

                                        <button className="rbt-btn btn-gradient  rbt-switch-btn rbt-switch-y mt-3" onClick={() => navigate("/register")}><span data-text={translateSync("Sign Up")}>   {translateSync('Sign Up')}</span></button>


                                    )}
                                </li>
                            </ul>
                        </div>
                </nav>
            </div >






            <div className="modal fade bd-example-modal-lg" id="courseModal" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg ">
                    <div className="modal-content">
                        <div className="programs-section  ">
                            <div className="container my-5" >
                                <h3 className="text-center text-bg-light-color fw-bold mb-4"> {translateSync('Knowledge Areas')}</h3>
                                {/* Knowledge Areas Grid */}
                                <div className="row">
                                    {/* Online Class */}
                                    <div className="col-md-5">
                                        <h5 className="text-left fw-bold mb-3" style={{ paddingBottom: "10px" }}> {translateSync('Online Class')}</h5>
                                        <div className="row g-3">
                                            {categoryList.length > 0 && categoryList.map((item, index) => {
                                                if (item.categoryType === "1" && item.categoryStatus === "Active") {
                                                    return (
                                                        <div key={index} className="col-4 category-list" onClick={() => editForm(item.id)}>
                                                            <div className="program-card position-relative">
                                                                <img src={IMAGE_URL + item.categoryImage} className="img-fluid rounded" alt={item.categoryName} />
                                                                <div className="overlay">
                                                                    <p className="fw-bold  text-white">{translateSync(item.categoryName)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>

                                    {/* Vertical Divider */}
                                    <div className="col-md-2 d-flex justify-content-center align-items-center">
                                        <div className="border-end h-100"></div>
                                    </div>

                                    {/* Classroom - Original Dynamic Mapping */}
                                    <div className="col-md-5">
                                        <h5 className="text-left fw-bold mb-3" style={{ paddingBottom: "10px" }}>{translateSync('Classroom')}</h5>
                                        <div className="row g-3">
                                            {categoryList.length > 0 && categoryList.map((item, index) => {
                                                if (item.categoryType === "2" && item.categoryStatus === "Active") {
                                                    return (
                                                        <div key={index} className="col-4 category-list" onClick={() => editForm(item.id)}>
                                                            <div className="program-card position-relative">
                                                                <img src={IMAGE_URL + item.categoryImage} className="img-fluid rounded" alt={item.categoryName} />
                                                                <div className="overlay">
                                                                    <p className="fw-bold text-white">{translateSync(item.categoryName)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>

                                {/* Certification & Training Locations */}
                                <div className="bg-light mt-5 p-4 rounded shadow-sm" style={{ boxShadow: " 0px 0px 10.3px 0px #00000040" }}>
                                    <div className="row">
                                        <div className="col-md-5 text-center">
                                            {/* <h5 className="fw-bold">Our Certifications</h5>
                                            <p style={{ textAlign: "center" }}> We don’t just offer courses. We offer credibility. Every iLap program is certified to meet UAE and global standards, because your growth deserves more than good enough.</p> */}

                                            {/* <div className="col-md-6 text-white text-align-left certificad-left-column" >
                        <h2 className="fw-bold" style={{textAlign:"center"}}>Our Certifications</h2>
                    </div> */}
                                            {/* <p>We offer internationally recognized and industry-approved training to ensure high-quality education.</p> */}
                                            {/* <div className="d-flex justify-content-center">
                                                <img src="/img/dubai-img.png" alt="Dubai Knowledge" className="me-3" width="100" />

                                            </div> */}
                                        </div>
                                        {/* Vertical Divider */}
                                        <div className="col-md-2 d-flex justify-content-center align-items-center">
                                            <div className="border-end h-100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
.account-wrapper {
    position: relative;
}

.account-dropdown {
    position: absolute;
    top: 40px;
    right: 0;
    width: 200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
    opacity: 0;
    visibility: hidden;
    transform: translateY(8px);
    transition: all 0.2s ease;
    z-index: 1000;
}

.account-wrapper:hover .account-dropdown {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.account-dropdown .dropdown-item {
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 6px;
    text-decoration: none;
    color: #333;
    transition: background 0.2s ease;
}

.account-dropdown .dropdown-item:hover {
    background-color: #f5f5f5;
}

.account-dropdown .dropdown-item i {
    font-size: 14px;
}
`}
            </style>
        </>
    )
}

export default Header
